import React from 'react';
import { useUserData, StressLevel } from '@/context/UserDataContext';
import { getStressLevelOptions } from '../../shared/constants';
import { FormSection } from '../../shared/FormSection';
import AnimatedSelectionGroup from '../../AnimatedSelectionGroup';

interface StressLevelSelectionProps {
  error?: string;
  onComplete?: () => void;
}

const StressLevelSelection: React.FC<StressLevelSelectionProps> = ({ error, onComplete }) => {
  const { userData, setUserData } = useUserData();
  const stressOptions = getStressLevelOptions();

  const handleStressLevelChange = (value: StressLevel) => {
    setUserData(prev => ({ ...prev, stressLevel: value }));
  };

  return (
    <FormSection
      question="Hows your stress level been in the last 30 days?"
      helperText="Stress levels can affect your nutritional needs and supplement recommendations."
      error={error}
    >
      <AnimatedSelectionGroup
        options={stressOptions}
        value={userData.stressLevel}
        onChange={handleStressLevelChange}
        name="stress-level"
        onComplete={onComplete}
      />
    </FormSection>
  );
};

export default StressLevelSelection; 